import React, { useState, useEffect } from 'react';
import { API_URL } from '../../config';
import { authFetch } from '../../utils';

import telegramLogo from '../../assets/telegram-logo.png';

export default function SmokeDetectorForm({ detector, onSave, onCancel , setSearchId }) {
  const [detectorId, setDetectorId] = useState(detector?.detectorId || '');
  const [name, setName] = useState(detector?.name || '');
  const [location, setLocation] = useState(detector?.location?._id || '');
  const [locations, setLocations] = useState([]);
  const [facility, setFacility] = useState(detector?.facility?._id || '');
  const [facilities, setFacilities] = useState([]);


  const [alarmEnabled, setAlarmEnabled] = useState(detector?.alarmEnabled ?? false);
  const [alarmSMS, setAlarmSMS] = useState(detector?.alarmSMS ?? false);
  const [alarmPhoneCall, setAlarmPhoneCall] = useState(detector?.alarmPhoneCall ?? false);
  const [alarmTelegram, setAlarmTelegram] = useState(detector?.alarmTelegram ?? true);
  const [description, setDescription] = useState(detector?.description || '');

  const [successMessage, setSuccessMessage] = useState('');


  useEffect(() => {
    authFetch(`${API_URL}locations`)
      .then(res => res.json())
      .then(setLocations);
  }, []);

  useEffect(() => {
  authFetch(`${API_URL}facilities`)
    .then(res => res.json())
    .then(setFacilities);
}, []);


  useEffect(() => {
  if (detector) {
    setDetectorId(detector.detectorId || '');
    setName(detector.name || '');
    setLocation(detector.location?._id || '');
    setFacility(detector.facility?._id || '');
    setAlarmEnabled(detector.alarmEnabled ?? false);
    setAlarmSMS(detector.alarmSMS ?? false);
    setAlarmPhoneCall(detector.alarmPhoneCall ?? false);
    setAlarmTelegram(detector.alarmTelegram ?? true);
    setDescription(detector.description || '');
  }
}, [detector]);



const checkDetectorIdExists = async (id) => {
  const res = await authFetch(`${API_URL}smoke-detectors/${id}`);
  return (res.status === 200);
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!detector) {
      const exists = await checkDetectorIdExists(detectorId);
      if (exists) {
        alert('Ya existe un detector con ese ID. Elige otro.');
        return;
      }
    }

    const method = detector ? 'PUT' : 'POST';
    const url = detector
      ? `${API_URL}smoke-detectors/${detector.detectorId}`
      : `${API_URL}smoke-detector`;

    const payload = {
      detectorId,
      name,
      location,
      facility,
      alarmEnabled,
      alarmSMS,
      alarmPhoneCall,
      alarmTelegram,
      description
    };

    const res =await authFetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if( res.status !== 200 && res.status !== 201) {
      alert(`Error al guardar el detector, detector no encontrado. Código: ${res.status}`);
      return;
    }

    const savedDetector = await res.json();

    if (setSearchId) {
      setSearchId(detectorId); // ✅ Actualiza el campo de búsqueda
    }

    setSuccessMessage('✅ Detector guardado correctamente');
    setTimeout(() => setSuccessMessage(''), 5000); // Oculta el mensaje después de 5 segundos
    onSave(savedDetector);


};


const inputStyle = {
  padding: '0.75rem',
  fontSize: '1rem',
  borderRadius: '6px',
  border: '1px solid #ccc',
  width: '100%'
};

const fieldsetStyle = {
  border: '1px solid #ccc',
  borderRadius: '6px',
  padding: '1rem'
};

const legendStyle = {
  fontWeight: 'bold',
  marginBottom: '0.5rem'
};

const checkboxLabel = {
  display: 'block',
  marginBottom: '0.5rem'
};

const primaryButton = {
  padding: '0.75rem 1.5rem',
  backgroundColor: '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer'
};

const secondaryButton = {
  padding: '0.75rem 1.5rem',
  backgroundColor: '#6c757d',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer'
};


  return (
  <form
    onSubmit={handleSubmit}
    style={{
      maxWidth: '600px',
      margin: '0 auto',
      padding: '2rem',
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }}
  >
    <h3 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '1rem' }}>
      {detector ? 'Editar' : 'Crear'} Detector
    </h3>

    {successMessage && (
      <div style={{
        backgroundColor: '#d4edda',
        color: '#155724',
        padding: '0.75rem',
        borderRadius: '6px',
        border: '1px solid #c3e6cb',
        marginBottom: '1rem',
        textAlign: 'center'
      }}>
        {successMessage}
      </div>
    )}


    <input
      value={detectorId}
      onChange={e => setDetectorId(e.target.value)}
      placeholder="ID detector"
      required
      disabled={!!detector} // ✅ Deshabilita si estás editando
      style={{
        ...inputStyle,
        backgroundColor: detector ? '#e9ecef' : 'white',
        cursor: detector ? 'not-allowed' : 'text'
      }}
    />

    <input
      value={name}
      onChange={e => setName(e.target.value)}
      placeholder="Nombre"
      required
      style={inputStyle}
    />

    <select value={location} onChange={e => setLocation(e.target.value)} style={inputStyle}>
      <option value="">Selecciona Ubicación</option>
      {locations.map(loc => (
        <option key={loc._id} value={loc._id}>{loc.name}</option>
      ))}
    </select>

    <select value={facility} onChange={e => setFacility(e.target.value)} style={inputStyle}>
      <option value="">Selecciona Instalación</option>
      {facilities.map(fac => (
        <option key={fac._id} value={fac._id}>{fac.name}</option>
      ))}
    </select>

    <fieldset style={fieldsetStyle}>
      <legend style={legendStyle}>Alarmas</legend>
      <label style={checkboxLabel}>
        <input
          type="checkbox"
          checked={alarmEnabled}
          onChange={e => setAlarmEnabled(e.target.checked)}
        />
        🔔 Alarma habilitada
      </label>
      <label style={checkboxLabel}>
        <input
          type="checkbox"
          checked={alarmSMS}
          onChange={e => setAlarmSMS(e.target.checked)}
        />
        📩 Alarma por SMS
      </label>
      <label style={checkboxLabel}>
        <input
          type="checkbox"
          checked={alarmPhoneCall}
          onChange={e => setAlarmPhoneCall(e.target.checked)}
        />
        📞 Alarma por llamada
      </label>
      <label style={checkboxLabel}>
        <input
          type="checkbox"
          checked={alarmTelegram}
          onChange={e => setAlarmTelegram(e.target.checked)}
        />
        <img
                  src={telegramLogo}
                  alt="Telegram"
                  height={18}
                  width={18}
                  style={{ verticalAlign: 'middle', marginRight: '0.25rem' }}
                /> Alarma por Telegram
      </label>
    </fieldset>

    <textarea
      value={description}
      onChange={e => setDescription(e.target.value)}
      placeholder="Descripción (opcional)"
      rows={4}
      style={{ ...inputStyle, resize: 'vertical' }}
    />

    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <button type="submit" style={primaryButton}>{detector ? 'Actualizar' : 'Crear'}</button>
      <button type="button" onClick={onCancel} style={secondaryButton}>Cancelar</button>
    </div>
  </form>
);

}